export default function Footer() {
  return (
    <footer className="relative bg-slate-50 overflow-hidden">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent"></div>
      
      {/* Main Footer */}
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-5">
            <img 
              src="https://static.readdy.ai/image/d8b069ddd48bc477a2a24842dd85a982/329b63b1e93dd762fd884ab9d568547a.png" 
              alt="Jon&G" 
              className="h-10 mb-6"
            />
            <p className="text-slate-600 text-sm leading-relaxed mb-8 max-w-sm">
              人と組織の可能性を最大化する。人事組織・財務・営業コンサルティング、助成金活用診断、AI研修を通じて、企業の持続的な成長を支援します。
            </p>
            
            {/* Address Card */}
            <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-500"></i>
                </div>
                <div>
                  <p className="text-xs text-slate-400 mb-1">OFFICE</p>
                  <p className="text-slate-700 text-sm">
                    〒104-0061<br />
                    東京都中央区銀座一丁目22番11号<br />
                    銀座大竹ビジデンス 2F
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 md:gap-8">
              {/* Services */}
              <div>
                <h4 className="text-xs font-bold text-slate-900 mb-5 tracking-wider flex items-center gap-2">
                  <span className="w-4 h-px bg-amber-400"></span>
                  事業内容
                </h4>
                <ul className="space-y-3">
                  <li>
                    <a href="#services" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      各種コンサルティング
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      助成金活用診断・提案
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      AI研修
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      コーチング
                    </a>
                  </li>
                </ul>
              </div>

              {/* Company */}
              <div>
                <h4 className="text-xs font-bold text-slate-900 mb-5 tracking-wider flex items-center gap-2">
                  <span className="w-4 h-px bg-amber-400"></span>
                  会社情報
                </h4>
                <ul className="space-y-3">
                  <li>
                    <a href="#team" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      メンバー紹介
                    </a>
                  </li>
                  <li>
                    <a href="#company" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      会社概要
                    </a>
                  </li>
                  <li>
                    <a href="#contact" className="text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-amber-400 transition-colors"></i>
                      お問い合わせ
                    </a>
                  </li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h4 className="text-xs font-bold text-slate-900 mb-5 tracking-wider flex items-center gap-2">
                  <span className="w-4 h-px bg-amber-400"></span>
                  お問い合わせ
                </h4>
                <div className="space-y-4">
                  <a href="#contact" className="flex items-center gap-3 text-sm text-slate-500 hover:text-amber-600 transition-colors cursor-pointer group">
                    <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-amber-400/10 transition-colors">
                      <i className="ri-calendar-line text-slate-400 group-hover:text-amber-500 transition-colors"></i>
                    </div>
                    <span>無料相談を予約</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">&copy; 2025 Jon&Gコンサルティング株式会社. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-amber-600 transition-colors flex items-center gap-2">
            <span>Powered by</span>
            <span className="font-medium">Readdy</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
